import AppInitView from "src/sections/appInit/view/appInit-view";

export default function AppInitPage() {
  return (
    <>
      <AppInitView />
    </>
  );
}
